import axios from 'axios';

const normalizeApiBaseUrl = () => {
  const rawBaseUrl = process.env.REACT_APP_API_URL || '';
  const trimmedBaseUrl = rawBaseUrl.trim().replace(/\/+$/, '');

  if (!trimmedBaseUrl) {
    return '/api';
  }

  return trimmedBaseUrl.endsWith('/api')
    ? trimmedBaseUrl
    : `${trimmedBaseUrl}/api`;
};

const garbageServicesApi = axios.create({
  baseURL: normalizeApiBaseUrl()
});

export const getGarbageNeighborhoods = async ({ date, selectedUserType = 3 }) => {
  const response = await garbageServicesApi.get('/garbage-services/neighborhoods', {
    params: {
      date,
      selectedUserType
    }
  });

  return response.data;
};

export const getGarbageMapData = async ({ zoneId, date, selectedUserType = 3, neighborhoodName = '' }) => {
  const response = await garbageServicesApi.get('/garbage-services/map-data', {
    params: {
      zoneId,
      date,
      selectedUserType,
      neighborhoodName
    }
  });

  return response.data;
};
